export default {
  title: '验证您的身份',
  subtitle: '请输入患者电话号码的后 4 位或订单号的后 4 位以查看配送详情。',
  'type-phone': '患者电话（后 4 位）',
  'type-order': '订单号（后 4 位）',
  code: '后 4 位数字',
  submit: '继续',
  'attempts-remaining': '剩余尝试次数：{count}',
  blocked: '尝试次数过多。请在 {minutes} 分钟后重试。',
  'invalid-code': '验证码不正确，请重试。',
  expired: {
    title: '链接已过期',
    description: '该订单已无法访问（14 天有效期已过）。',
  },
  forbidden: {
    title: '拒绝访问',
    description: '您没有权限查看此页面。',
  },
}
